import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";
import { sendJob, type SendJobInput, type SendJobResult } from "./sendJob";

/** „An Vidario senden" from the create or edit form. Resolves with
 * `started: false` (and the saved Draft) when the search was refused. */
export function useSendJob(): UseMutationResult<SendJobResult, Error, SendJobInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => sendJob(client, input),
    onSuccess: (result) => {
      qc.invalidateQueries({ queryKey: ["jobs"] });
      qc.invalidateQueries({ queryKey: queryKeys.job(result.job.id) });
      // Starting a search uses one of the recruiter's searches.
      qc.invalidateQueries({ queryKey: queryKeys.me() });
      if (result.started && result.run) {
        qc.setQueryData(queryKeys.sourcingRun(result.job.id), result.run);
      } else {
        qc.invalidateQueries({ queryKey: queryKeys.sourcingRun(result.job.id) });
      }
    },
  });
}
